import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0d6b3226"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "nav-container"
};
const _hoisted_2 = {
  class: "nav-left"
};
const _hoisted_3 = {
  class: "nav-right"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "色", -1));
import { computed, ref } from 'vue';
import { Bell, Menu, Search, SwitchButton } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';
import Avatar from './components/Avatar.vue';
import Breadcrumb from './components/Breadcrumb.vue';
import store from '@/store';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const themeOptions = [{
      label: '蓝色',
      value: 'blue',
      color: '#409eff'
    }, {
      label: '绿色',
      value: 'green',
      color: '#67c23a'
    }, {
      label: '紫色',
      value: 'purple',
      color: '#8f5fe8'
    }, {
      label: '橙色',
      value: 'orange',
      color: '#e6a23c'
    }];
    const searchText = ref('');
    const currentTheme = computed(() => store.state.app.theme);
    const handleThemeChange = theme => {
      store.commit('app/setTheme', theme);
    };
    const toggleSidebar = () => {
      store.commit('app/setSiderType');
    };
    const handleLogout = async () => {
      await store.dispatch('app/logout');
      ElMessage({
        message: '已退出登录',
        type: 'success'
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        class: "mobile-sidebar-btn",
        circle: "",
        icon: _unref(Menu),
        "aria-label": "显示侧边菜单",
        onClick: toggleSidebar
      }, null, 8, ["icon"]), _createVNode(Breadcrumb)]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
        modelValue: searchText.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchText.value = $event),
        class: "top-search",
        placeholder: "搜索",
        clearable: "",
        "prefix-icon": _unref(Search)
      }, null, 8, ["modelValue", "prefix-icon"]), _createVNode(_component_el_tooltip, {
        content: "通知",
        placement: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          class: "theme-switch-btn",
          circle: "",
          icon: _unref(Bell)
        }, null, 8, ["icon"])]),
        _: 1
      }), _createVNode(_component_el_dropdown, {
        trigger: "click",
        onCommand: handleThemeChange
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(themeOptions, item => {
            return _createVNode(_component_el_dropdown_item, {
              key: item.value,
              command: item.value,
              class: _normalizeClass({
                'theme-active': currentTheme.value === item.value
              })
            }, {
              default: _withCtx(() => [_createElementVNode("span", {
                class: "theme-swatch",
                style: _normalizeStyle({
                  background: item.color
                })
              }, null, 4), _createTextVNode(" " + _toDisplayString(item.label), 1)]),
              _: 2
            }, 1032, ["command", "class"]);
          }), 64))]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_button, {
          class: "theme-switch-btn",
          circle: ""
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_button, {
        class: "logout-btn",
        type: "primary",
        plain: "",
        icon: _unref(SwitchButton),
        onClick: handleLogout
      }, {
        default: _withCtx(() => [_createTextVNode(" 退出 ")]),
        _: 1
      }, 8, ["icon"]), _createVNode(Avatar, {
        class: "nav-item"
      })])]);
    };
  }
});